import { gql } from '@apollo/client'
import { ANNOUNCEMENT_FIELDS } from './announcement-queries'

// ── Authoring (message.write) ──────────────────────────────────────────────────

export const CREATE_ANNOUNCEMENT = gql`
  ${ANNOUNCEMENT_FIELDS}
  mutation CreateAnnouncement($input: CreateAnnouncementInput!) {
    createAnnouncement(input: $input) {
      ...AnnouncementFields
    }
  }
`

export const UPDATE_ANNOUNCEMENT = gql`
  ${ANNOUNCEMENT_FIELDS}
  mutation UpdateAnnouncement($id: Int!, $input: UpdateAnnouncementInput!) {
    updateAnnouncement(id: $id, input: $input) {
      ...AnnouncementFields
    }
  }
`

export const PUBLISH_ANNOUNCEMENT = gql`
  ${ANNOUNCEMENT_FIELDS}
  mutation PublishAnnouncement($id: Int!) {
    publishAnnouncement(id: $id) {
      ...AnnouncementFields
    }
  }
`

export const ARCHIVE_ANNOUNCEMENT = gql`
  mutation ArchiveAnnouncement($id: Int!) {
    archiveAnnouncement(id: $id) {
      id
      status
    }
  }
`

// ── Consumption (baseline — any authenticated member) ───────────────────────────

export const MARK_ANNOUNCEMENT_READ = gql`
  mutation MarkAnnouncementRead($id: Int!) {
    markAnnouncementRead(id: $id) {
      id
      myReceipt {
        read_at
        acknowledged_at
      }
    }
  }
`

export const ACKNOWLEDGE_ANNOUNCEMENT = gql`
  mutation AcknowledgeAnnouncement($id: Int!) {
    acknowledgeAnnouncement(id: $id) {
      id
      myReceipt {
        read_at
        acknowledged_at
      }
    }
  }
`

// ── Type management (message.write) ─────────────────────────────────────────────

const ANNOUNCEMENT_TYPE_FIELDS = gql`
  fragment AnnouncementTypeFields on AnnouncementType {
    id
    key
    label
    requires_ack
    priority
    active
  }
`

export const CREATE_ANNOUNCEMENT_TYPE = gql`
  ${ANNOUNCEMENT_TYPE_FIELDS}
  mutation CreateAnnouncementType($input: CreateAnnouncementTypeInput!) {
    createAnnouncementType(input: $input) {
      ...AnnouncementTypeFields
    }
  }
`

export const UPDATE_ANNOUNCEMENT_TYPE = gql`
  ${ANNOUNCEMENT_TYPE_FIELDS}
  mutation UpdateAnnouncementType($id: Int!, $input: UpdateAnnouncementTypeInput!) {
    updateAnnouncementType(id: $id, input: $input) {
      ...AnnouncementTypeFields
    }
  }
`
